import { ChevronRight, ChevronDown, Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface TreeChevronProps {
  isExpanded: boolean;
  isLoading?: boolean;
  className?: string;
}

export function TreeChevron({ isExpanded, isLoading, className }: TreeChevronProps) {
  if (isLoading) {
    return (
      <Loader2
        className={cn('h-4 w-4 shrink-0 animate-spin text-muted-foreground', className)}
      />
    );
  }

  const Icon = isExpanded ? ChevronDown : ChevronRight;

  return (
    <Icon
      className={cn('h-4 w-4 shrink-0 text-muted-foreground transition-transform', className)}
    />
  );
}
